<template>
	<NuxtLayout>
		<InternalServerError
			:action-link="{ url: homepageUrl, text: 'Naar de homepage' }"
			:title="copy.title"
			:description-markdown="copy.descriptionMarkdown"
		/>
	</NuxtLayout>
</template>
<script lang="ts" setup>
import type { NuxtError } from '#app';
import useClientApi from '~/api/useClientApi';
import useBaseApiUrl from '~~/composables/useBaseApiUrl';

const props = defineProps({
	// eslint-disable-next-line vue/require-default-prop
	error: Object as () => NuxtError,
});

const baseApiUrl = useBaseApiUrl();
useClientApi(baseApiUrl);
useNloProvideApi('portal');
const config = useRuntimeConfig();

const homepageUrl = computed(() => {
	return config.public.portalBaseUrl;
});

onMounted(() => {
	if (props.error) {
		// eslint-disable-next-line no-console
		console.error('Error from Nuxt', props.error);
	}
});

const copy = computed(() => {
	const descriptionMarkdown = `Er is iets fout gegaan en dat kan verschillende redenen hebben. Je kunt het beste terug gaan naar de homepage en vanuit daar verder gaan.`;
	switch (props.error?.statusCode) {
		case 404: {
			return {
				title: 'Deze pagina is niet bereikbaar',
				descriptionMarkdown:
					'De pagina die je zoekt bestaat niet of niet meer. Controleer het adres van de website of ga terug naar de homepage.',
			};
		}
		default: {
			return {
				title: 'Oeps, er is iets fout gegaan',
				descriptionMarkdown,
			};
		}
	}
});
</script>
